import { Box, Grid } from '@mui/material';
import React, { memo, useEffect } from 'react';
import MultiProgress from 'react-multi-progress';
import { useAppSelector } from 'src/store';
import DocManagementService from '../../documentUpload/service/DocManagementService';
import StudyCompleteness from './StudyCompleteness';

/**
 * Study completeness component.
 *
 * @param props  Props received from parent component.
 *
 * @returns Study completeness component.
 */
const StudyCompletenessComponent = (props: any) => {
  const { tmfLevel, study, country, site } = props;
  const [studyCompletenessCount, setStudyCompletenessCount] = React.useState<any>({});
  const [studyCompletenessTypes, setStudyCompletenessTypes] = React.useState<any>([]);
  const studyCompleteness = new StudyCompleteness();
  const docService = new DocManagementService();
  const [apiStatus, setApiStatus] = React.useState<boolean>(false);
  const user: any = useAppSelector(state => state.user.user);

  /**
   * Get all planning details.
   *
   * @param tmfLevel  TMF Level.
   * @param study Study.
   * @param country Country.
   * @param site Site.
   */
  const getAllPlanningDetails = async (tmfLevel: any, study: any, country: any, site: any) => {
    const params = {
      module_section_related: 'TMFLandingPage',
      parent_entity_related: ''
    };
    const res: any = await docService.getAllPlanning(tmfLevel, study, country, site, params);
    if (res.data) {
      let studyCompletenessCountMetrics = {};
      if (res.data.tmf_document_metrics) {
        studyCompletenessCountMetrics = res.data.tmf_document_metrics;
        setStudyCompletenessCount(studyCompletenessCountMetrics);
      } else {
        setStudyCompletenessCount(studyCompletenessCountMetrics);
      }
      const studyCompletenessTypes = studyCompleteness.data(studyCompletenessCountMetrics, tmfLevel);
      setStudyCompletenessTypes(studyCompletenessTypes);
    }
  };

  useEffect(() => {
    // Get the required data in container on hierarchy data change.
    if (study !== '--') {
      getAllPlanningDetails(tmfLevel, study, country, site);
    } else {
      setStudyCompletenessCount({});
      const studyCompletenessTypes = studyCompleteness.data({}, tmfLevel);
      setStudyCompletenessTypes(studyCompletenessTypes);
    }
  }, [tmfLevel, study, country, site]);

  return (
    <>
      <h3 style={{ marginTop: '0', marginBottom: '12px' }}>Study Completeness</h3>
      <Grid container className="chart-wrapper-landing">
        <Grid md={12} sm={12} xs={12} className="chart-description ">
          <ul>
            {studyCompletenessTypes?.map((item: any) => {
              if (item.enabled) {
                return (
                  <li key={item.key} className="status-col">
                    <Box>
                      <strong>
                        <item.icon fontSize="large" className="bigIcon" style={{ color: item.color }} />
                      </strong>
                    </Box>
                    <Box>
                      {item.name} <br />
                      <strong style={{ color: item.color }}>{item.valueActual}</strong>/ {item.totalCount}
                    </Box>
                  </li>
                );
              }
            })}
          </ul>
          <div className="completed">
            <strong>
              {Math.round(
                ((studyCompletenessCount?.tmf_doc_approved_count || 0) /
                  (studyCompletenessCount?.tmf_doc_total_count || 0)) *
                  100
              ) || 0}
              %
            </strong>{' '}
            &nbsp;Complete
            <MultiProgress
              transitionTime={1}
              elements={studyCompletenessTypes}
              height={15}
              backgroundColor={studyCompleteness.colorCode?.nodata}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(StudyCompletenessComponent);
